import React from 'react';

import './MapToolbar.scss';

type MapToolbarProps = {
  children: React.ReactNode;
};

export const MapToolbar = ({ children }: MapToolbarProps) => {
  return <div className='dmx-mapToolbar'>{children}</div>;
};
